import { h } from 'preact'
import { useLayoutEffect } from 'preact/hooks'

export const PrefooterSeo = ({ title, columns }) => {
   useLayoutEffect(() => {
      var observer = ''

      const insertSeoFooter = () => {
         const sitemap = document.getElementById('o-footer-sitemap')
         const accesDirect = document.getElementById('o-footer-acces-direct')
         const accesDirectOld = document.getElementById('o-footer-accesDirect') // a supprimer quand renov elco footer done
         const target = sitemap || accesDirect || accesDirectOld

         if (target) {
            if (observer !== '') observer.disconnect()
            const prefooterSeo = document.getElementById('prefooterSeo')
            if (sitemap) {
               sitemap.parentNode.insertBefore(prefooterSeo, sitemap.nextSibling)
            } else if (accesDirect) {
               accesDirect.parentNode.insertBefore(prefooterSeo, accesDirect)
            } else if (accesDirectOld) {
               accesDirectOld.parentNode.insertBefore(prefooterSeo, accesDirectOld) // a supprimer quand renov elco footer done
            }
            prefooterSeo.classList.remove('d-none')
         }
      }

      let isFooterReady =
         document.getElementById('o-footer-sitemap') !== null ||
         document.getElementById('o-footer-acces-direct') !== null ||
         document.getElementById('o-footer-accesDirect') !== null // a supprimer quand renov elco footer done
            ? true
            : false

      if (isFooterReady) {
         insertSeoFooter()
      } else {
         observer = new MutationObserver(insertSeoFooter)
         let footerWrapper = document.getElementById('footer-wrapper')
         if (footerWrapper) {
            observer.observe(footerWrapper, { subtree: true, childList: true })
         }
      }
   }, [])

   return (
      <div id="prefooterSeo" class="prefooter o-footer-sitemap o-marge d-none">
         <div class="o-footer-content">
            <div>
               <h3 class="prefooter-title m-0 lead font-weight-bold pt-1">{title}</h3>
               <ul class="categories">
                  {columns.map((item) => {
                     return (
                        <li>
                           {item.map((link) => {
                              return <a href={link.URL}>{link.label}</a>
                           })}
                        </li>
                     )
                  })}
               </ul>
            </div>
         </div>
      </div>
   )
}
